import axios from 'axios';
import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin';
window.gsap = gsap;
gsap.registerPlugin(ScrollToPlugin);

// get checkboxes to validate each slide
const solutionCheck = document.querySelectorAll('input[name="solution"]');
const serviceCheck = document.querySelectorAll('input[name="service[]"]');
const employeeCheck = document.querySelectorAll('input[name="employees"]');
const contactMethodCheck = document.querySelectorAll('input[name="contact_method"]');

// toggle visibility of service checkboxes based on selected solution
solutionCheck.forEach((solution) => {
	solution.addEventListener('change', (event) => {
		let solutionName = event.target.getAttribute('id');

		serviceCheck.forEach((service) => {
			service.checked = false;
			service.parentElement.classList.remove('active');

			if (service.parentElement.classList.contains(solutionName)) {
				service.parentElement.classList.add('active');
			}
		});
	});
});

// hide virtual call option for 1-25 employees
const virtualCall = document.querySelector('#virtual-call');
virtualCall.parentElement.style.display = 'none';
employeeCheck.forEach((employee) => {
	employee.addEventListener('change', (event) => {
		let employeesVal = event.target.getAttribute('value');

		if (employeesVal == '1-25') {
			virtualCall.checked = false;
			virtualCall.parentElement.style.display = 'none';
		} else {
			virtualCall.parentElement.style.display = null;
		}
	});
});

// custom swiper nav arrows
const srfSliderPrev = document.querySelector('.strategy-review-form__slider-nav .swiper__prev');
const srfSliderNext = document.querySelector('.strategy-review-form__slider-nav .swiper__next');

// init form slider
const srfSlider = new Swiper('.strategy-review-form .swiper', {
	modules: [Pagination],
	autoHeight: true,
	spaceBetween: 30,
	pagination: {
		el: document.querySelector('.strategy-review-form').querySelector('.swiper-pagination'),
		type: 'progressbar',
	},
});

// toggle disabled nav arrow styles for first and last slide
srfSlider.on('slideChange', function () {
	if (this.realIndex > 0) {
		srfSliderPrev.classList.remove('swiper-button-disabled');
	} else {
		srfSliderPrev.classList.add('swiper-button-disabled');
	}

	if (this.realIndex < this.slides.length - 1) {
		srfSliderNext.classList.remove('swiper-button-disabled');
	} else {
		srfSliderNext.classList.add('swiper-button-disabled');
	}
});

// previous slide
srfSliderPrev.addEventListener('click', (event) => {
	if (srfSlider.realIndex != 0) {
		srfSlider.slidePrev();
	}
});

// next slide
srfSliderNext.addEventListener('click', (event) => {
	let slideIndex = srfSlider.realIndex;

	if (slideIndex == 0) {
		srfSliderValidation(solutionCheck, slideIndex);
	} else if (slideIndex == 1) {
		srfSliderValidation(serviceCheck, slideIndex);
	} else if (slideIndex == 2) {
		srfSliderValidation(employeeCheck, slideIndex);
	} else if (slideIndex == 3) {
		srfSliderValidation(contactMethodCheck, slideIndex);
	}
});

// check input is checked before moving to next slide
function srfSliderValidation(input, index) {
	let slideValid = false;

	for (let i = 0; i < input.length; i++) {
		if (input[i].checked) {
			slideValid = true;
		}
	}

	if (slideValid == true) {
		srfSlider.slideNext();
	} else {
		gsap.set(srfSlider.slides[index].querySelectorAll('.pill-checkbox__bg'), { transition: 'none' });
		gsap.timeline().to(srfSlider.slides[index].querySelectorAll('.pill-checkbox__bg'), { borderColor: '#d01110', backgroundColor: '#f7bec0', duration: 0.4, ease: 'power2.in' }).to(srfSlider.slides[index].querySelectorAll('.pill-checkbox__bg'), { borderColor: '#a5a8b5', backgroundColor: '#fff', duration: 0.3, ease: 'power2.out', clearProps: 'transition,borderColor,backgroundColor' }, '>0.2');
	}
}

// form vars
const strategyReviewForm = document.querySelector('#strategy-review-form');
const strategyReviewFormWrap = document.querySelector('#strategy-review-form-wrapper');
// ajax loader
let loader = document.createElement('div');
loader.className = 'lds-ripple';
loader.appendChild(document.createElement('div'));
loader.appendChild(document.createElement('div'));
// form submit
strategyReviewForm.addEventListener('submit', (event) => {
	event.preventDefault();
	let formData = new FormData(strategyReviewForm);
	strategyReviewForm.classList.add('ajaxing');
	strategyReviewForm.append(loader);
	formData.append('action', 'strategy_review_form');
	// form ajax
	axios
		.post(ajaxurl, formData)
		.then((response) => {
			// console.log(response);
			// remove ajax and loader
			strategyReviewForm.classList.remove('ajaxing');
			loader.remove();
			// form response and status vars
			let formMessage = strategyReviewFormWrap.querySelector('.form-response');
			formMessage.innerHTML = '';
			let formStatus;
			if (response.data !== '' && response.data.constructor === Object) {
				formStatus = response.data.status;
			} else {
				formStatus = response.data;
			}
			// get response message based on status
			let responseMessage = strategyReviewFormWrap.querySelector('.template-' + formStatus).content.cloneNode(true);
			if (formStatus == 'success') {
				strategyReviewFormWrap.innerHTML = '';
				strategyReviewFormWrap.append(responseMessage);
				strategyReviewFormWrap.classList.add('strategy-review-form-success');
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'formSubmission',
					formType: 'Strategic Review',
				});
			} else {
				formMessage.append(responseMessage);
				formMessage.classList.add('form-response--' + formStatus);
				response.data.errors.forEach((error) => {
					let list = document.createElement('li');
					list.textContent = error;
					strategyReviewFormWrap.querySelector('#strategy-review-form-errors').append(list);
				});
			}
			// scroll response into view
			gsap.to(window, { delay: 0.2, duration: 0.7, scrollTo: { y: '.hero-form__content', offsetY: 100 }, ease: 'sine.out' });
		})
		.catch((error) => {
			console.log(error);
			strategyReviewForm.classList.remove('ajaxing');
		});
});
